'use client';
var classes = {"root":"m_1f271cf7","container":"m_cf06f58c"};

export { classes as default };
//# sourceMappingURL=RadarChart.module.css.mjs.map
